<template>
  <div class="w-full h-full overflow-auto">
    <div class="w-full absolute bottom-0 left-0 opacity-5 pointer-events-none">
      <img src="@/assets/images/backgrounds/register.webp" alt="" />
    </div>
    <div
      class="w-full h-full flex flex-col items-center justify-between relative"
    >
      <div></div>
      <div class="w-[80%] md:max-w-[350px] overflow-auto py-8">
        <div class="text-center">
          <div class="text-2xl font-semibold whitespace-nowrap title-color">
            {{ $t('register.title') }}
          </div>
          <div class="py-1"></div>
          <div class="font-semibold whitespace-nowrap description-color">
            {{ $t('register.subTitle') }}
          </div>
          <div class="py-3"></div>
        </div>
        <FormComponent
          class="w-full grid grid-cols-12 gap-x-4"
          :fields="fields"
          :onFormSubmited="
            data => {
              requestRegistration(data)
            }
          "
          :loading="false"
          ref="form"
        >
          <template #submitButton>
            <button class="hidden" type="submit" ref="submit"></button>
          </template>
        </FormComponent>
        <button
          class="buttonComponent mt-4 arrow w-full"
          @click="$refs.submit.click()"
        >
          {{ $t('register.continueButton') }}
        </button>
        <div class="text-center pt-8">
          <span>{{ $t('register.alreadyRegistered') }}</span> &nbsp;
          <router-link to="/login" class="text-primary-400 font-bold">
            {{ $t('register.login') }}
          </router-link>
        </div>
      </div>
      <div class="flex justify-center py-6">
        <div class="top-0 text-3xl font-bold relative">
          <div
            class="w-8 top-0 right-0 absolute translate-x-2/3 -translate-y-1/2"
          >
            <img
              src="@/assets/images/king-recharge-assets/crown-white.svg"
              class="w-full"
              alt=""
            />
          </div>
          <div>King Recharge</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormComponent from '../utils/FormComponent.vue'

export default {
  components: { FormComponent },
  props: {
    preFilledData: {
      type: Object,
      default() {
        return {}
      },
    },
    hideAffiliation: {
      type: Boolean,
      default: false,
    },
    hideWhatsapp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        {
          type: 'text',
          propertyName: 'lastName',
          label: this.$t('register.lastNameInputLabel'),
          defaultValue: '',
          required: true,
          class: 'col-span-6',
        },
        {
          type: 'text',
          propertyName: 'firstName',
          label: this.$t('register.firstNameInputLabel'),
          defaultValue: '',
          required: true,
          class: 'col-span-6',
        },
        {
          type: 'select',
          propertyName: 'phonePrefix',
          // inputProps: {
          //   disabled: true,
          // },
          options: this.$Countries
            .getSignupCountries()
            .map(country => `+${country.phonePrefix}`),
          label: '',
          defaultValue: ``,
          required: false,
          class:
            ' !w-[63px] relative z-[2] pl-3 locationCountry phonePrefix  [&_.inputContainer]:!bg-transparent [&_.inputContainer]:!border-none [&_.inputContainer]:!text-l [&_.inputContainer]:!absolute [&_.inputContainer]:!pl-3 [&_input]:!p-[0px] countryPrefix',
        },
        {
          type: 'number',
          propertyName: 'phoneNumber',
          label: this.$t('register.phoneNumberInputLabel'),
          defaultValue: '',
          required: true,
          inputProps: {
            allowTrailingZero: true,
            minLenght: 6,
          },
          class:
            'col-span-12 [&_input]:!pl-[80px] [&_label]:!pl-[65px] [&_input:focus_~_label]:!pl-[0px]  [&_input:not(.empty)_~_label]:!pl-[0px]',
        },
        {
          type: 'email',
          propertyName: 'email',
          label: this.$t('register.emailInputLabel'),
          defaultValue: this.preFilledData?.email || '',
          required: true,
          class: 'col-span-12',
        },
        {
          type: 'password',
          propertyName: 'password',
          label: this.$t('register.passwordInputLabel'),
          placeHolder: '********',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
        },
        {
          type: 'text',
          propertyName: 'affiliationCode',
          label: this.$t('register.affiliationCodeInputLabel'),
          defaultValue: '',
          required: false,
          inputProps: {},
          class: { 'col-span-12': true, hidden: this.hideAffiliation },
        },
        {
          type: 'text',
          propertyName: 'whatsappNumber',
          label: this.$t('register.whatsappInputLabel'),
          defaultValue: '',
          required: false,
          class: { 'col-span-12': true, hidden: this.hideWhatsapp },
        },
        {
          type: 'toggle',
          propertyName: 'acceptMoreThan18',
          label: this.$t('register.acceptMoreThan18'),
          defaultValue: false,
          required: true,
          class:
            ' -my-7 col-span-12 [&_.inputContainer]:!bg-transparent [&_.inputContainer]:!border-none [&_.inputContainer]:!text-sm [&_input]:!p-[0px]',
        },
        {
          type: 'toggle',
          propertyName: 'termOfUse',
          label: this.$t('register.acceptTerms', {
            termsLinkAttr: `href="https://web.kingrecharges.com/cgu" target="_blank" class="underline text-primary"`,
          }),
          defaultValue: false,
          required: true,
          class:
            ' -my-7 col-span-12 [&_.inputContainer]:!bg-transparent [&_.inputContainer]:!border-none [&_.inputContainer]:!text-sm [&_input]:!p-[0px]',
        },
      ],
      eventsIds: [],
      userCountry: {},
      loading: false,
    }
  },
  mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    const id = this.$Events.handleEvent(
      'registration_done',
      this.onRegistrationDone,
    )
    const id2 = this.$Events.handleEvent(
      'registration_failed',
      this.onRegistrationFailed,
    )
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
    this.loadReferralCode()
    this.loadUserCountry()
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async loadUserCountry() {
      this.$refs.form.setFieldValue('phonePrefix', '+229')
      const locationData =
        await this.$Events.sendDataRequestResolve('locationData')
      const countryCode = locationData?.metaData?.locationData?.countryCode
      const allowedCountryCodes = this.$Countries
        .getSignupCountries()
        .map(country => country.countryCode)
      if (!allowedCountryCodes.includes(countryCode)) return
      this.userCountry = this.$Countries.find(countryCode || 'BJ')
      this.$refs.form.setFieldValue(
        'phonePrefix',
        '+' + this.userCountry.phonePrefix,
      )
    },
    loadReferralCode() {
      const referralCode = this.$QuickStorage.getStored('referralCode')
      if (!referralCode) return
      this.fields[6].defaultValue = referralCode
      this.fields[6].inputProps.disabled = true
    },
    requestRegistration(inputData) {
      if (this.loading) return
      this.loading = true

      const phoneNumber =
        `${inputData.phonePrefix}${inputData.phoneNumber}`.replace(/^\+/, '')
      // const userCountry = this.$Countries.getPhoneCountry(phoneNumber)
      // if (!userCountry) {
      //   this.$Events.dispatchEvent('toast_notification', {
      //     title: 'Erreur de chargement des données',
      //     body: "Nous n'arrivons pas à retrouver votre pays. Veuillez réouvrir l'app puis réessayer. Merci",
      //   })
      //   return
      // }
      const data = JSON.parse(JSON.stringify(inputData))
      data.phoneNumber = phoneNumber
      delete data.phonePrefix
      data.useDirectConnection = this.preFilledData?.email
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent('registration_requested', data)
    },
    onRegistrationDone() {
      this.$router.push('/home')
      this.$Events.dispatchEvent('finish_loading')
      this.loading = false
    },
    onRegistrationFailed(data) {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        type: 'warning',
        title: this.$t('register.registrationError'),
        body:
          this.$t(data.messageId) ||
          this.$t('register.registrationErrorFallback'),
      })
      this.loading = false
    },
  },
}
</script>
